import {
  actionType,
  CartItem,
  initialStateType,
} from './src/contexts/CartReducer'
import {toast} from 'react-hot-toast'
import cart from './cart'
import alerts from './src/config/alerts.json'
import { useRouter } from 'next/router'
type BasicDispatch = (action: actionType) => void
type AppThunk<ReturnType = void> = (
  dispatch: BasicDispatch,
  state: initialStateType,
) => Promise<ReturnType>

const getAlertsByLocale = () => {
  if (typeof window === 'undefined') {
    return alerts.en
  }

  try {
    const raw = localStorage.getItem('user-locale-choice')
    const parsed = raw ? JSON.parse(raw) : null

    const locale = parsed?.locale

    if (locale === 'ar') return alerts.ar
    if (locale === 'en') return alerts.en

    return alerts.en
  } catch {
    return alerts.en
  }
}

export const fetchCart = (): AppThunk => async dispatch => {
  const cartData = await cart.fetchCart()
  dispatch({type: 'SET_CART', payload: cartData})
}

export const addItem =
  (item: CartItem): AppThunk =>
  async dispatch => {
    await cart.addToCart(item)
    const cartState = await cart.fetchCart()
    dispatch({type: 'SET_CART', payload: cartState})
  }

export const updateItem =
  (item: CartItem): AppThunk =>
  async dispatch => {
    await cart.updateCartItem(item)
    const cartState = await cart.fetchCart()
    dispatch({type: 'SET_CART', payload: cartState})
  }

export const removeItem =
  (itemId: string): AppThunk =>
  async dispatch => {
    await cart.removeCartItem(itemId)
    const cartState = await cart.fetchCart()
    dispatch({type: 'SET_CART', payload: cartState})
  }

export const updateAddress =
  (address: any): AppThunk =>
  async dispatch => {
    try {
      const t = getAlertsByLocale()
      await cart.updateAddress(address)
      const cartState = await cart.fetchCart()
      toast.success(t.cart_address_add)
      dispatch({type: 'SET_CART', payload: cartState})
    } catch (error: any) {
      toast.dismiss()
      toast.error(error?.response?.data?.message || 'Something went wrong.')
    }
  }

export const updateAddressType =
  (addressType: 'pickup_point' | 'home_delivery' | 'self_pickup'): AppThunk =>
  async dispatch => {
    await cart.updateAddressType(addressType)
    const cartState = await cart.fetchCart()
    dispatch({type: 'SET_CART', payload: cartState})
  }

export const applyCoupon =
  (coupon: string): AppThunk<any> =>
  async dispatch => {
    try {
      const t = getAlertsByLocale()
      const response = await cart.applyCoupon(coupon)

      const cartState = await cart.fetchCart()
      dispatch({ type: 'SET_CART', payload: cartState })

      return response // ✅ now TS knows this is returned
    } catch (error: any) {
      toast.dismiss()
      toast.error(error?.response?.data?.message || 'Something went wrong.')
      return null
    }
  }

export const removeCoupon = (): AppThunk => async dispatch => {
  const t = getAlertsByLocale()
  await cart.removeCoupon()
  const cartState = await cart.fetchCart()
  toast.dismiss()
  toast.success(t.coupon_removed)
  dispatch({type: 'SET_CART', payload: cartState})
}

export const emptyCart = (): AppThunk => async dispatch => {
  await cart.emptyCart()
  const cartState = await cart.fetchCart()
  dispatch({type: 'SET_CART', payload: cartState})
}